// Util function to create the hreflang for the page.
export const createHrefLang = (content, agentDetails = {}) => {
  let subStr;
  let profileId = (agentDetails && agentDetails.id) || null;
  const { localUrl: url, inLanguage, silos } = content || {};
  if (
    (inLanguage === "en" && url && silos === "FAR_AGENTS_SRP") ||
    (inLanguage === "en" && url && silos === "FAR_AGENTS_LDP")
  ) {
    subStr = profileId ? profileId : url.split("/realestateagents/").pop();
  } else if (inLanguage === "es" && url && silos !== ("FAR_TEAMS_SRP" || "FAR_AGENCY_SRP")) {
    subStr = profileId ? profileId : url.split("/realestateagents/es/").pop();
  } else {
    //Default value will be empty string
    return {
      engUrl: "",
      esUrl: "",
    };
  }

  return {
    engUrl: `https://www.realtor.com/realestateagents/${subStr}`,
    esUrl: `https://www.realtor.com/realestateagents/es/${subStr}`,
  };
};
